import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/admin.vue").then(m => m.default || m)),
  auth: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)),
  "sign-up": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/sign-up.vue").then(m => m.default || m))
}